import { time } from "console";
import makeRequest, { makeParams } from "../api/makeRequest";
import { RequestMethods } from "../api/requestMethode";
import url from "../api/urls";

export class ClientService {
    static async getAllShifts() {
        return await makeRequest(url.getAllShifts, RequestMethods.GET);
    }

    static async getCountInfo(shiftId: any, payload: any) {
        return await makeRequest(url.stats.getCountInfo + "/" + shiftId, RequestMethods.POST, payload);
    }

    static async getVerificationWiseCount(shiftId: any, payload: any) {
        return await makeRequest(url.stats.getVerificationWiseCount + "/" + shiftId, RequestMethods.POST, payload);
    }


    static async getVerificationData(shiftId: any, pageNumber: any, pageSize: any, payload: any) {
        const params = makeParams([
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize },
            // {index:'searchText', value:searchText}
        ])
        return await makeRequest(url.client.getVerificationData + "/" + shiftId + params, RequestMethods.POST, payload);
    }

    static async getCenterCount(shiftId: any) {
        return await makeRequest(url.client.getCenterCount + "/" + shiftId, RequestMethods.GET);
    }

    static async getCenterStats(shiftId: any, centerPreference: any, zone: any, state: any, city: any, pageNumber: number, pageSize: number) {
        const params = makeParams([
            {
                index: "centerPreference",
                value: centerPreference
            },
            {
                index: "zone",
                value: zone
            },

            {
                index: "state",
                value: state
            },
            {
                index: "city",
                value: city
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "pageSize",
                value: pageSize
            }
        ])
        return await makeRequest(url.client.getCenterStats + "/" + shiftId + params, RequestMethods.GET);
    }

    static async getOperatorStats(shiftId: any, type: any, pageNumber: number, pageSize: number, payload: any) {
        const params = makeParams([
            {
                index: "stat_type",
                value: type
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "pageSize",
                value: pageSize
            }
        ])
        return await makeRequest(url.stats.getOperatorStats + "/" + shiftId + params, RequestMethods.POST, payload)
    }



    static async getCenterStatsDetails(shiftId: any, centerId: any, qParams: string) {
        return await makeRequest(url.client.centerStatsDetails + "/" + shiftId + "/" + centerId + qParams, RequestMethods.GET)
    }


    static async getUniqueCity(shiftId: any) {
        return await makeRequest(url.client.getUniqueCity + "/" + shiftId, RequestMethods.GET);
    }
    static async getUniqueCenter(shiftId: any) {
        return await makeRequest(url.client.getUniqueCenter + "/" + shiftId, RequestMethods.GET);
    }
    static async getUniqueCenter2(shiftId: any, qParams: string = "") {
        return await makeRequest(url.client.getUniqueCenter2 + "/" + shiftId + qParams, RequestMethods.GET);
    }
    static async getUniqueZone(shiftId: any, qParams: string = "") {
        return await makeRequest(url.client.getUniquesZone + "/" + shiftId + qParams, RequestMethods.GET);
    }
    static async getUniqueState(shiftId: any) {
        return await makeRequest(url.client.getUniqueState + "/" + shiftId, RequestMethods.GET);
    }

    static async getUsers(shiftId: any, payload: any) {
        return await makeRequest(url.client.getUsers + "/" + shiftId, RequestMethods.POST, payload)
    }

    static async getUsersData(shiftId: any, pageSize: any, pageNumber: any, payload: any) {
        const params = makeParams([{ index: "pageNumber", value: pageNumber }, { index: "pageSize", value: pageSize }]);
        return await makeRequest(url.client.getUserData + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async downloadVerifiedZip(shiftId: any) {
        return await makeRequest(url.client.downloadVerifiedZip + "/" + shiftId, RequestMethods.GET);
    }

    static async searchStudentByRollNo(shiftId: any, rollNo: any) {
        const params = makeParams([{ index: "search", value: rollNo }]);
        return await makeRequest(url.client.searchByRollNo + "/" + shiftId + params, RequestMethods.GET);
    }

    static async getDatabyUserId(shiftId: any, userId: any) {
        return await makeRequest(url.client.getDatabyUserId + "/" + shiftId + "/" + userId, RequestMethods.GET)
    }

    static async getAllCSRReport(shiftId: any, pageSize: number, pageNumber: number, centerId: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "centerId",
                value: centerId
            },
        ])
        return await makeRequest(url.client.getAllCSRReport + "/" + shiftId + params, RequestMethods.GET)
    }

    static async getVerificationEnums() {
        return await makeRequest(url.getVerificationEnums, RequestMethods.GET)
    }

    static async getAllBypassData(shiftId: any, pageSize: number, pageNumber: number, payload: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
        ])
        return await makeRequest(url.client.getAllBypassData + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async getDropdownData(shiftId: any) {
        return await makeRequest(url.client.getDropdownData + "/" + shiftId, RequestMethods.GET)
    }

    static async getInvigilators(shiftId: any, pageNumber: number, pageSize: number, payload: any) {
        const params = makeParams([
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize },
            // {index:'searchText', value:searchText}
        ])
        return await makeRequest(url.client.getInvigilators + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async getInvigilatorStats(shiftId: any, payload: any) {
        return await makeRequest(url.stats.getInvigilatorStats + "/" + shiftId, RequestMethods.POST, payload)
    }

    static async getVerifiedCount(shiftId: any, payload: any) {
        return await makeRequest(url.stats.getVerifiedCount + "/" + shiftId, RequestMethods.POST, payload)
    }

    static async getVerificationCountStats(shiftId: any, payload: any) {
        return await makeRequest(url.stats.getVerificationCountStats + "/" + shiftId, RequestMethods.POST, payload)
    }

    static async getVerificationByState(shiftId: any, payload: any) {
        return await makeRequest(url.stats.getVerificationByState + "/" + shiftId, RequestMethods.POST, payload)
    }

    static async getZones(shiftId: any) {
        return await makeRequest(url.dropdown.getZones + "/" + shiftId, RequestMethods.GET)
    }

    static async getStates(shiftId: string, params: string) {
        console.log("getstate called");
        return await makeRequest(url.dropdown.getStates + "/" + shiftId + params, RequestMethods.GET);
    }

    static async getCities(shiftId: string, params: string) {
        return await makeRequest(url.dropdown.getCities + "/" + shiftId + params, RequestMethods.GET);
    }

    static async getCenters(shiftId: string, params: string) {
        return await makeRequest(url.dropdown.getCenters + "/" + shiftId + params, RequestMethods.GET);
    }

    // static async getVerifiedUserCount(shiftId: string) {
    //     return await makeRequest(url.stats.getVerifiedUserCount + "/" + shiftId, RequestMethods.POST);
    // }
    static async getStatsByStateData(shiftId: any) {
        return await makeRequest(url.client.getStatsByStateData + "/" + shiftId, RequestMethods.GET)
    }

    static async getCityStatsTime(shiftId: any) {
        return await makeRequest(url.client.getCityStatsTime + "/" + shiftId, RequestMethods.GET)
    }

    static async getStatsByCityData(shiftId: any, city?: any) {
        return await makeRequest(url.client.getStatsByCityData + "/" + shiftId + "/" + city, RequestMethods.GET)
    }

    static async getVerificationTrends(shiftId: any, payload: any) {
        return await makeRequest(url.client.getVerificationTrends + "/" + shiftId, RequestMethods.POST, payload)
    }

    static async getCityDetails(shiftId: string, city: string) {
        return await makeRequest(url.client.getCityDetails + "/" + shiftId + "/" + city, RequestMethods.GET);
    }

    static async downloadShiftReport(shiftId: string, email: string) {
        return await makeRequest(url.client.downloadShiftReport + "/" + shiftId + "?emailTo=" + email, RequestMethods.GET);
    }

    static async downloadShiftVerificationData(shiftId: string, email: string) {
        return await makeRequest(url.client.downloadShiftVerificationData + "/" + shiftId + "?emailTo=" + email, RequestMethods.GET);
    }

    static async getShiftRequestData(shiftId: string) {
        return await makeRequest(url.client.getShiftRequestData + "/" + shiftId, RequestMethods.GET);
    }

    static async updateRequestCount(exportId: string) {
        return await makeRequest(url.client.updateRequestCount + "/" + exportId, RequestMethods.PUT);
    }

    static async getAllCourses() {
        return await makeRequest(url.dropdown.getUniqueCourses, RequestMethods.GET);
    }

    static async getExceptionReport(shiftId: any, pageSize: number, pageNumber: number, payload: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
        ])
        return await makeRequest(url.client.getExceptionReport + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async getInvigilatorsLog(shiftId: any, pageNumber: number, pageSize: number, payload: any) {
        const params = makeParams([
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "pageSize",
                value: pageSize
            },
        ])
        return await makeRequest(url.client.invigilatorsData + "/" + shiftId + params, RequestMethods.POST, payload);
    }

    static async getAttendanceReport(shiftId: any, pageSize: number, pageNumber: number, payload: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
        ])
        return await makeRequest(url.client.getAttendanceReport + "/" + shiftId + params, RequestMethods.POST, payload)
    }
    static async getBiometricStats(shiftId: any, pageSize: number, pageNumber: number, payload: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
        ])
        return await makeRequest(url.client.operatorStats + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async downloadNotStarted(shiftId: any) {
        return await makeRequest(url.client.downloadNotStarted + "/" + shiftId, RequestMethods.GET);
    }

    static async getVenueWiseAttendanceStats(shiftId: any, payload: any) {
        return await makeRequest(url.client.getVenueWiseAttendanceStats + "/" + shiftId, RequestMethods.POST, payload);
    }

    static async getFacialMismatchData(shiftId: any, pageSize: number, pageNumber: number, payload: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            }
        ]);
        return await makeRequest(url.client.getFacialMismatchData + "/" + shiftId + params, RequestMethods.POST, payload);
    }

    static async getVerificationDataV2(shiftId: any, pageNumber: number, pageSize: number, payload: any) {
        const params = makeParams([
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize }
        ]);
        return await makeRequest(url.client.getVerificationV2 + "/" + shiftId + params, RequestMethods.POST, payload);
    }

    static async getAttendanceStats(shiftId: any, pageNumber: number, pageSize: number, payload: any) {
        const params = makeParams([
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize }
        ]);
        return await makeRequest(url.client.getAttendanceStats + "/" + shiftId + params, RequestMethods.POST, payload);
    }

    static async getInvigilatorDetails(invigilatorId: any) {
        return await makeRequest(url.client.getInvigilatorDetails + "/" + invigilatorId, RequestMethods.GET);
    }

    static async syncPages(payload: any) {
        return await makeRequest(url.client.syncPages, RequestMethods.POST, payload);
    }

    static async getAllowedPages() {
        return await makeRequest(url.client.allowedPages, RequestMethods.GET);
    }

    static async getReverificationStats() {
        return await makeRequest(url.reverification.getStats, RequestMethods.GET);
    }

    static async getReverificationColleges() {
        return await makeRequest(url.reverification.getColleges, RequestMethods.GET);
    }

    static async getReverificationCollegeStats(collegeId: any) {
        const query = makeParams([
            { index: "collegeId", value: collegeId }
        ])
        return await makeRequest(url.reverification.getCollegeStats + query, RequestMethods.GET);
    }

    static async getAllUsersReverifications(pageNumber: number, pageSize: number, collegeId: any, stream: string) {
        const params = makeParams([
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "collegeId",
                value: collegeId
            },
            {
                index: "stream",
                value: stream
            }
        ])

        return await makeRequest(url.client.getAllUsersReverifications + params, RequestMethods.GET)
    }

    static async getAllStreams() {
        return await makeRequest(url.client.getAllStreams, RequestMethods.GET)
    }

    static async downloadReverificationCSV( collegeId: any, stream: string) {
        const params = makeParams([
            {
                index: "collegeId",
                value: collegeId
            },
            {
                index: "stream",
                value: stream
            }
        ])

        return await makeRequest(url.client.donwloadReverificationCSV + params, RequestMethods.GET)
    }

     static async getReverificationStudentsData(status: any, collegeId:any) {
        const params = makeParams([
            {
                index: "status",
                value: status
            },
        ])

        return await makeRequest(url.client.getReverificationStudentsData + "/" + collegeId +  params, RequestMethods.GET)
    }

    static async getCollegeStatsData() {
        return makeRequest(url.client.getCollegeStatsData, RequestMethods.GET);
    }


    static async getFacialExceptions(pageNumber: number, pageSize: number) {
        const params = makeParams([
            { index: 'page', value: pageNumber },
            { index: 'size', value: pageSize }
        ]);
        return await makeRequest(url.client.getVerificationsWithException + params, RequestMethods.GET);
    }

    static async acceptFacialException(id: string) {
        return await makeRequest(url.client.acceptFacialException + "/" + id, RequestMethods.POST);
    }

    static async rejectFacialException(id: string) {
        return await makeRequest(url.client.rejectFacialException + "/" + id, RequestMethods.POST);
    }
}
